import React, { useState } from 'react';
import Modal from '../../shared/Modal';

const ApiKeyCreatedModal = ({ apiKey, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = apiKey;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <Modal title="API Key Aangemaakt" onClose={onClose} size="md">
      <div className="alert alert-warning">
        <i className="fa fa-exclamation-triangle mr-2" />
        <strong>Let op:</strong> Dit is de enige keer dat je de volledige API key te zien krijgt.
        Kopieer en bewaar deze op een veilige plek.
      </div>

      <div className="form-group">
        <label>API Key</label>
        <div className="api-key-copy-row">
          <input
            type="text"
            className="form-control font-monospace"
            value={apiKey}
            readOnly
            style={{ fontFamily: 'monospace', fontSize: '0.9em' }}
          />
          <button
            type="button"
            className={`btn ${copied ? 'btn-success' : 'btn-outline-secondary'}`}
            onClick={handleCopy}
          >
            {copied ? (
              <>
                <i className="fa fa-check mr-1" />
                Gekopieerd
              </>
            ) : (
              <>
                <i className="fa fa-copy mr-1" />
                Kopieer
              </>
            )}
          </button>
        </div>
      </div>

      <div className="mt-4">
        <button
          type="button"
          className="btn btn-primary"
          onClick={onClose}
        >
          Ik heb de key opgeslagen
        </button>
      </div>
    </Modal>
  );
};

export default ApiKeyCreatedModal;
